<template lang='pug'>
  .review-results(v-if='review && review.attributes')
    .row
      .col-12
        span.review-rating.rating-container
          product-rating-stars(:rating='review.attributes.rating')
    .row
      .col-12
        h4.h4.review-heading
          span.review-variant-name(v-if='variants.length > 1')
            | {{ variantName(review.relationships.variant.data.id) }}
            |
            | -
            |
          span.review-title(v-text='review.attributes.title')
        p.review-text(v-text='review.attributes.text')
    .row
      .col-12.review-details-container
        ProductReviewDetails(
          :date='review.attributes["created-at"]'
          :author-name='review.attributes["reviewer-name"]'
          :country-name='review.attributes["country-name"]'
          :is-staff='review.attributes["is-staff"]'
          :promotion-label='review.attributes["incentivized-label"]'
        )
</template>

<script>
import { mapState } from 'vuex'
import get from 'lodash/get'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import ProductRatingStars from '../product-rating-stars.vue'
import ProductReviewDetails from '../product-review-details.vue'

export default {
  components: {
    ProductRatingStars,
    ProductReviewDetails
  },

  props: {
    review: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState({
      product: state => state.product.product,
      variants: state => state.product.productVariants
    }),
    reviewCount () {
      return this.product.attributes['reviews-count']
    }
  },

  mounted () {
    if ($('.review-rating-rating')) {
      $('.review-rating-rating').rateit({ max: 5 })
    }
  },

  methods: {
    formatDate: (date) => format(parse(date), 'DD MMM YYYY'),
    variantName (id) {
      if (this.variants.length === 0) {
        return ''
      }
      const variant = this.variants.find(v => v.id === id.toString())
      return get(variant, 'attributes.name', '')
    }
  }
}
</script>

<style scoped lang='scss'>
  .review-results {
    padding: 25px 10px;

    .review-heading {
      margin-bottom: 5px;
    }

    .review-rating {
      margin-right: 30px;
    }

    .review-text {
      line-height: 20px;
      overflow-wrap: break-word;
    }
  }

  .review-details-container {
    margin-top: 15px;
  }
</style>
